import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 12,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Manufacturer</th>
					<th>Document File Name</th>
					<th>Document Description</th>
					<th>Section / Page</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Allen Bradley</td>
					<td>GuardLogix Controller User Manual.pdf</td>
					<td>GuardLogix Controllers User Manual</td>
					<td>Appendix A – Status Indicators Page 135</td>
				</tr>
				<tr>
					<td>FANUC</td>
					<td>M-710iC_Mechanical Unit Operators Manual B-82274EN 09.pdf</td>
					<td>Mechanical Unit Operator’s Manual</td>
					<td>Section 9 – Troubleshooting Pages: 103-109</td>
				</tr>
				<tr>
					<td>FANUC</td>
					<td>r30ib r30ib plus controller maintenance manual marebcntr04121e rev l.pdf</td>
					<td>R30iB/R30iB Plus Controller Maintenance Manual</td>
					<td>Section 3 – Troubleshooting Pages: 12 - 96</td>
				</tr>
				<tr>
					<td>FANUC</td>
					<td>r30ib r30ib mate r30ib plus r30ib mate plus controller.pdf</td>
					<td>R30iB/R30iB Plus/ R30iB Mate Plus Controller Operator Manual</td>
					<td>Appendix A – Troubleshooting Pages 59-60</td>
				</tr>
				<tr>
					<td>GRACO</td>
					<td>312376EN-T.pdf</td>
					<td>Check-Mate Pump Instructions </td>
					<td>Section – Troubleshooting Pages: 16-17</td>
				</tr>
				<tr>
					<td>Kollmorgen</td>
					<td>AKD User Guide EN Rev C.pdf </td>
					<td>AKD User Guide </td>
					<td>Section 18 – Troubleshoot the AKD Page: 257</td>
				</tr>
				<tr>
					<td>SICK</td>
					<td>operating instructions c4000 standard and_c4000_advanced safety light_curtains en_im0011945.pdf</td>
					<td>C4000 Standard and C4000 Advanced Operating Instructions</td>
					<td>Section 10 – Fault Diagnosis Pages 67 -71</td>
				</tr>
				<tr>
					<td>SMC</td>
					<td>EX600-SEN_eng.pdf</td>
					<td>EX600-SEN Fieldbus System Operation Manual</td>
					<td>Section – Setting and Adjustment Section – LED Display Section – Troubleshooting Page: 1</td>
				</tr>
				<tr>
					<td>SMC</td>
					<td>PS-OMH0003-C.pdf</td>
					<td>Digital Pressure Switch Operation Manual</td>
					<td>Section – Troubleshooting Page: 27</td>
				</tr>

				<tr>
					<td>TELEDYNE</td>
					<td>Genie Nano Series User Manual.pdf</td>
					<td>Genie Nano Series Camera User’s Manual</td>
					<td>Section – Troubleshooting Pages 289 - 297</td>
				</tr>
				<tr>
					<td>TELEDYNE</td>
					<td>154257-Dalsa-Genie-Nano-5GigE-User-Manual.pdf</td>
					<td>Genie Nano-5G Series Camera User Manual</td>
					<td>Section – Troubleshooting Pages 213 - 222</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{ display: 'block', width: '23vw' }}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="12">
							12
						</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const OEMTable = styled(TableComp)``;

export default OEMTable;
